.profileListContainer {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	width: 100%;
	height: 100%;
	gap: 0.75rem;
	padding: 0.5rem;
	box-sizing: border-box;
}

.profileGrid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 1rem;
	padding: 0.5rem;
	width: 100%;
	overflow-y: auto;
	box-sizing: border-box;

	&.initialState {
		grid-template-rows: repeat(2, 1fr);
		height: 100%;
	}

	&.expandedState {
		grid-template-rows: auto;
		max-height: 600px;
	}
}

.profileButtonWrapper {
	display: flex;
	flex-direction: column-reverse;
	gap: 0.5rem;
	padding: 0rem;
	box-sizing: border-box;
	position: relative;
	justify-content: center;
	height: 100%;

	.profileButton {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		width: 100%;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: 0 0.5rem 0.5rem 0.5rem;
		border-radius: inherit;
		box-sizing: border-box;
	}

	.headerRow {
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
		padding: 0.75rem 0.5rem 0 0.5rem;
		box-sizing: border-box;

		.badgeRow {
			display: flex;
			gap: 0.625rem;
			flex-wrap: wrap;
		}

		.profileBadge {
			border-radius: 6px;
			flex-shrink: 0;
			min-width: unset;
			width: fit-content;

			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 26px;

			& span {
				font-weight: 500;
				font-size: 0.75rem;
				line-height: 1.6;
			}
		}
	}

	.titleRow {
		display: flex;
		flex-direction: row;
		gap: 0.5rem;
		width: 100%;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;

		.profileName {
			color: #101828;
			font-size: 1rem;
			font-weight: 600;
			line-height: 1.4;
		}
	}

	.profileDesc {
		color: #4a5565;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
		text-align: center;
	}

	.viewMoreWrapper {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.viewMore {
		font-size: 0.875rem;
		font-weight: 400;
		line-height: 1.6;
		width: fit-content;
	}
}

.profileToolbar {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	max-width: 60%;

	& .profileSearchFieldWrapper {
		margin: 0;
	}
}

.presetProfileGrid {
	display: grid;
	width: 100%;
	height: 100%;
	overflow: hidden;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	gap: 1rem;

	& > * {
		width: 100%;
		height: 100%;
		min-width: 0;
		min-height: 0;
		display: flex;
	}
}

.recBadge:global(.MuiChip-root) {
	background: linear-gradient(180deg, rgba(129, 73, 227, 0.8) 0%, rgba(135, 75, 211, 0.8) 100%);
	border-radius: 8px;
	height: 22px;
	width: fit-content;
	min-width: unset;
	display: flex;
	justify-content: center;
	align-items: center;

	& span {
		color: #ffffff;
		font-weight: 700;
		font-size: 0.625rem;
		line-height: 1.6;
	}
}

.tooltipWrapper:global(.MuiTooltip-tooltip) {
	background-color: transparent;
	border: none;
	padding: 0;
}

.tooltipArrow:global(.MuiTooltip-arrow) {
	color: #fff;
}

.presetTooltip {
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px #00000040;
	border-radius: 12px;
	padding: 0.75rem;
	box-sizing: border-box;
	gap: 0.625rem;
	align-items: flex-start;
	justify-content: center;

	& .header {
		color: #333333;
		font-weight: 600;
		font-size: 0.8125rem;
		line-height: 1.6;
	}

	& .presetGrid {
		display: grid;
		grid-template-columns: 30% 1fr;
		width: 100%;
		row-gap: 0.625rem;
		column-gap: 0.5rem;

		/* Target every child starting from the 3rd one (the 2nd row) */
		& > *:nth-child(n + 3) {
			border-top: 1px solid #dedede;
			padding-top: 0.625rem;
			margin-top: 0;
		}
	}

	& .title {
		color: #333333;
		font-weight: 500;
		font-size: 0.75rem;
		line-height: 1.6;
	}

	& .description,
	& li {
		color: #424242;
		font-weight: 400;
		font-size: 0.75rem;
		word-wrap: wrap;
		line-height: 1.6;
	}
}

.bulletList {
	margin: 0;
	list-style-type: disc;
	padding: 0;

	& li {
		margin: 0;
		padding: 0;
	}
}

.profileAction {
	height: fit-content;
}

@media (max-width: 768px) {
	.profileToolbar {
		max-width: unset;
		width: 100%;
	}

	.presetProfileGrid {
		grid-template-columns: minmax(0, 1fr);
		grid-template-rows: unset;
	}

	.profileGrid {
		grid-template-columns: minmax(0, 1fr);

		&.initialState {
			grid-template-rows: unset;
			height: unset;
		}

		&.expandedState {
			grid-template-rows: unset;
			max-height: unset;
		}
	}

	.profileListContainer {
		padding: 0;
	}

	.profileButtonWrapper {
		.headerRow {
			.badgeRow {
				flex-direction: column;
			}
		}
	}
}
